exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disable-events[data-v-acd79672] {\n  pointer-events: none;\n}\n.inactive[data-v-acd79672] {\n  background-color: rgba(0, 0, 0, 0.12) !important;\n}", ""]);

// exports
